/* eslint-disable indent */
/* eslint-disable no-console */
// code guru suggestion
export const removeItemFromLocalStorage = () => {
	try {
		const safeRemove = (removeKey) => {
			removeKey.map((key) => {
				const sanitizedKey = encodeURIComponent(key).replace(/[^a-zA-Z0-9-_]/g, '');
				if (localStorage.getItem(sanitizedKey)) {
					localStorage.removeItem(sanitizedKey);
				}
			});
		};
		const removeKey = [
			'modelOpenDuplicate', 'ro-dict', 'ro_payload', 'Active_DualequationCCPP', 'StandAloneARGO', 'recircRo-dict', 'recirc-dict',
			// 'default_unit_set_dict', 'unit_set_dict','system-units',
			'previous_ro_pressure_unit', 'stream_ouput_data', 'ro_ouput_data', 'form', 'feed-dict', 'dosing-dict',
			'cf-dict', 'edi-dict', 'pump-dict', 'hp-pump-dict', 'options', 'ro-stage-data', 'roHPLoop-stage-data',
			'mixSplit-dict', 'previous_flow_unit', 'previous_pressure_unit', 'previous_power_unit',
			'cf-output-dict', 'streamNum_dict', 'stripper-dict', 'cd-output-dict', 'edi-output-dict',
			'project_info', 'flow_dict', 'feed_flow_dict', 'product_flow_dict', 'stream_input_dict',
			'ro_argo_temp', 'work_exc-dict', 'press_exc-dict', 'pelton_wheel-dict', 'ro-dict-temp',
			'current-unit-work', 'pelton-unit-work', 'turbo-unit-work', 'turbo_charger-dict',
			'feedRows', 'previous_units', 'systemRecovery', 'clro-dict', 'clro_payload', 'clro-dict-temp',
			'clro-stage-data', 'clro_ouput_data', 'tds', 'shared_file_count'
		];
		safeRemove(removeKey);
	} catch (error) {
		console.error('Error in removeItemFromLocalStorage:', error.message);
	}
};